import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationChangePassword } from "./validationChangePassword";
import {
  TextField, Button, Typography, Box,
  Grid, Avatar, Container, InputAdornment, IconButton
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useState, useEffect } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useSearchParams, useNavigate } from "react-router-dom";
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { patchPassword } from "../../../services/ClientesServices";

export const ClienteChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [countdown, setCountdown] = useState(3);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();


  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationChangePassword)
  });

  // Redirect if missing params
  useEffect(() => {
    //checkear token
    const accessToken = localStorage.getItem('token');
    if (!accessToken) {
      navigate('/login');
    }
  }, []);

  // Countdown effect
  useEffect(() => {
    if (!success) return;
    if (countdown <= 0) {
      navigate('/login');
      return;
    }
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(timer);
  }, [success, countdown, navigate]);

  const onSubmit = async ({ cli_pass }) => {
    setError('');
    try {
      const data = await patchPassword({ contrasena: cli_pass })
      setSuccess(true);
    } catch {
      setError('No se pudo cambiar la contraseña. Pongase en contacto con soporte tecnico');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'background.paper',
        padding: 3,
        borderRadius: 2,
        boxShadow: 3
      }}>
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Cambiar contraseña
        </Typography>

        <Grid container spacing={2} marginTop={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nueva contraseña*"
              type={showPassword ? 'text' : 'password'}
              {...register('cli_pass')}
              error={!!errors.cli_pass}
              helperText={errors.cli_pass?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Repetir contraseña*"
              type={showPasswordRepeat ? 'text' : 'password'}
              {...register('cli_pass_confirm')}
              error={!!errors.cli_pass_confirm}
              helperText={errors.cli_pass_confirm?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPasswordRepeat(!showPasswordRepeat)}>
                      {showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
        </Grid>

        {success && (
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography color="success.main">
              Contraseña cambiada con éxito.
            </Typography>
            <Typography color="textSecondary">
              Redirigiendo al login en {countdown}s...
            </Typography>
          </Box>
        )}

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={!isValid || success}
          sx={{ mt: 3, mb: 2 }}
        >
          Cambiar contraseña
        </Button>
        <Typography variant="body2" align="center">
          Ir al inicio{' '}
          <MuiLink component={RouterLink} to="/">
            aquí
          </MuiLink>
        </Typography>
      </Box>
    </Container>
  );
};
